import { useState, useEffect } from 'react';
import { useHttpUtils } from './useHttpUtils';

const baseUrl = "api/v1";

export function useEquipmentTypes(includeDeleted, businessUnitId) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [equipmentTypes, setEquipmentTypes] = useState([]);

    useEffect(() => {
        const getEquipmentTypes = async function () {
            if (businessUnitId > 0) {
                let url = `${baseUrl}/equipmentType/?includeDeleted=${includeDeleted}&businessUnitId=${businessUnitId}`;
                let errorMessagePrefix = "Failed to get equipment types: ";
                await fetchHelper(fetchDataAuthenticated, url, setEquipmentTypes, errorMessagePrefix);
            }
            else {
                setEquipmentTypes([]);
            }
        };

        getEquipmentTypes();

    }, [businessUnitId, includeDeleted]);

    return equipmentTypes;
}

export function useBusinessUnitTypes() {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [businessUnitTypes, setBusinessUnitTypes] = useState([]);

    useEffect(() => {
        const getBusinessUnitTypes = async function () {

            const url = `${baseUrl}/businessunit/types/`;
            const errorMessagePrefix = "Failed to get business unit types: ";
            await fetchHelper(fetchDataAuthenticated, url, setBusinessUnitTypes, errorMessagePrefix);

        };

        getBusinessUnitTypes();

    }, [fetchDataAuthenticated]);

    return businessUnitTypes;
}

export function useLines(includeDeleted, businessUnitId) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [lines, setLines] = useState([]);

    useEffect(() => {
        const getLines = async function () {
            if (businessUnitId > 0) {
                let url = `${baseUrl}/line/?includeDeleted=${includeDeleted}&businessUnitId=${businessUnitId}`;
                let errorMessagePrefix = "Failed to get lines: ";
                await fetchHelper(fetchDataAuthenticated, url, setLines, errorMessagePrefix);
            }
            else {
                setLines([]);
            }
        };

        getLines();

    }, [businessUnitId, includeDeleted]);

    return lines;
}

export function useQualities(includeDeleted, businessUnitId) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [qualities, setQualities] = useState([]);

    useEffect(() => {
        const getQualities = async function () {
            if (businessUnitId > 0) {
                let url = `${baseUrl}/quality/?includeDeleted=${includeDeleted}&businessUnitId=${businessUnitId}`;
                let errorMessagePrefix = "Failed to get qualities: ";
                await fetchHelper(fetchDataAuthenticated, url, setQualities, errorMessagePrefix);
            }
            else {
                setQualities([]);
            }
        };

        getQualities();

    }, [businessUnitId, includeDeleted]);

    return qualities;
}

export function useEquipment(includeDeleted, businessUnitId) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [equipment, setEquipment] = useState([]);

    useEffect(() => {
        const getEquipment = async function () {
            if (businessUnitId > 0) {
                let url = `${baseUrl}/equipment/?includeDeleted=${includeDeleted}&businessUnitId=${businessUnitId}`;
                let errorMessagePrefix = "Failed to get equipment: ";
                await fetchHelper(fetchDataAuthenticated, url, setEquipment, errorMessagePrefix);
            }
            else {
                setEquipment([]);
            }
        };

        getEquipment();

    }, [businessUnitId, includeDeleted]);

    return equipment;
}

export function useRecipe(name, businessUnit) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [recipe, setRecipe] = useState();

    useEffect(() => {
        const getRecipe = async function () {
            let url = `${baseUrl}/recipe/nameAndBusinessUnit?name=${name}&businessUnitCode=${businessUnit}`;
            let errorMessagePrefix = "Failed to get recipe: ";
            await fetchHelper(fetchDataAuthenticated, url, setRecipe, errorMessagePrefix);
        };

        if (name !== undefined && businessUnit !== undefined) {
            getRecipe();
        }
    }, [name, businessUnit]);



    return { recipe, setRecipe };
}

export function useRecipes(refreshToken) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [recipes, setRecipes] = useState([]);

    useEffect(() => {
        const getRecipes = async function () {
            let url = `${baseUrl}/recipe`;
            let errorMessagePrefix = "Failed to get recipes";
            await fetchHelper(fetchDataAuthenticated, url, setRecipes, errorMessagePrefix);

        };

        getRecipes();
    }, [refreshToken]);

    return recipes;
}

export function useRecipeTypes(includeDeleted, businessUnitId) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [recipeTypes, setRecipeTypes] = useState([]);

    useEffect(() => {
        const getRecipeTypes = async function () {
            if (businessUnitId > 0) {
                let url = `${baseUrl}/recipetype/?includeDeleted=${includeDeleted}&businessUnitId=${businessUnitId}`;
                let errorMessagePrefix = "Failed to get recipe types: ";
                await fetchHelper(fetchDataAuthenticated, url, setRecipeTypes, errorMessagePrefix);
            }
            else {
                setRecipeTypes([]);
            }
        };

        getRecipeTypes();

    }, [businessUnitId, includeDeleted]);

    return recipeTypes;
}

export function useRecipeProperties(includeDeleted, businessUnitId) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [recipeProperties, setRecipeProperties] = useState([]);

    useEffect(() => {
        const getRecipeProperties = async function () {
            if (businessUnitId > 0) {
                let url = `${baseUrl}/recipeproperty/?includeDeleted=${includeDeleted}&businessUnitId=${businessUnitId}`;
                let errorMessagePrefix = "Failed to get recipe types: ";
                await fetchHelper(fetchDataAuthenticated, url, setRecipeProperties, errorMessagePrefix);
            }
            else {
                setRecipeProperties([]);
            }
        };

        getRecipeProperties();

    }, [businessUnitId, includeDeleted]);

    return recipeProperties;
}

export function useRecipeDataTypes(includeDeleted, businessUnitId) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [recipeDataTypes, setRecipeDataTypes] = useState([]);

    useEffect(() => {
        const getRecipeDataTypes = async function () {
            if (businessUnitId > 0) {
                let url = `${baseUrl}/recipedatatype/?includeDeleted=${includeDeleted}&businessUnitId=${businessUnitId}`;
                let errorMessagePrefix = "Failed to get recipe data types: ";
                await fetchHelper(fetchDataAuthenticated, url, setRecipeDataTypes, errorMessagePrefix);
            }
            else {
                setRecipeDataTypes([]);
            }
        };

        getRecipeDataTypes();

    }, [businessUnitId, includeDeleted]);

    return recipeDataTypes;
}

export function useCalcFunctions() {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [calcFunctions, setCalcFunctions] = useState([]);

    useEffect(() => {
        const getCalcFunctions = async function () {
            let url = `${baseUrl}/qualityfunctions/GetQualityCalculateFunctions`;
            let errorMessagePrefix = "Failed to get calc functions: ";
            await fetchHelper(fetchDataAuthenticated, url, setCalcFunctions, errorMessagePrefix);
        };

        getCalcFunctions();

    }, []);

    return calcFunctions;
}

export function useLabFunctions() {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [labFunctions, setLabFunctions] = useState([]);

    useEffect(() => {
        const getLabFunctions = async function () {
            let url = `${baseUrl}/qualityfunctions/GetLabCalculateFunctions`;
            let errorMessagePrefix = "Failed to get lab functions: ";
            await fetchHelper(fetchDataAuthenticated, url, setLabFunctions, errorMessagePrefix);
        };

        getLabFunctions();

    }, []);

    return labFunctions;
}

export function useOffspecFunctions() {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [offspecFunctions, setOffspecFunctions] = useState([]);

    useEffect(() => {
        const getOffspecFunctions = async function () {
            let url = `${baseUrl}/qualityfunctions/GetQualityOffspecFunctions`;
            let errorMessagePrefix = "Failed to get offspec functions: ";
            await fetchHelper(fetchDataAuthenticated, url, setOffspecFunctions, errorMessagePrefix);
        };

        getOffspecFunctions();

    }, []);

    return offspecFunctions;
}

export function useGetSplittableBatches(lotNumber) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [loading, setLoading] = useState(true);
    const [splittableBatches, setSplittableBatches] = useState([]);

    useEffect(() => {
        setLoading(true);
        getSplittableBatches(lotNumber);
    }, [lotNumber]);

    async function getSplittableBatches(lotNumber) {
        let url = `${baseUrl}/lot/${lotNumber}/splittablebatches`;
        let errorMessagePrefix = `Failed to get splittable batches for lot '${lotNumber}': `;
        await fetchHelper(fetchDataAuthenticated, url, setSplittableBatches, errorMessagePrefix, setLoading);
    }

    return { splittableBatches, loading };
}

export function useGetSplittableSilos(lotNumber) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [loading, setLoading] = useState(true);
    const [splittableSilos, setSplittableSilos] = useState([]);

    useEffect(() => {
        setLoading(true);
        getSplittableSilos(lotNumber);
    }, [lotNumber]);

    async function getSplittableSilos(lotNumber) {
        let url = `${baseUrl}/lot/${lotNumber}/splittablesilos`;
        let errorMessagePrefix = `Failed to get splittable silos for lot '${lotNumber}': `;
        await fetchHelper(fetchDataAuthenticated, url, setSplittableSilos, errorMessagePrefix, setLoading);
    }

    return { splittableSilos, loading };
}

export function useLotStatuses(includeGraded) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [loading, setLoading] = useState(true);
    const [lotStatuses, setLotStatuses] = useState([]);

    useEffect(() => {
        getLotStatuses();
    }, []);

    async function getLotStatuses() {
        let url = `${baseUrl}/lotStatus?includeGraded=${includeGraded}`;
        let errorMessagePrefix = `Failed to get lotStatuses': `;
        await fetchHelper(fetchDataAuthenticated, url, setLotStatuses, errorMessagePrefix, setLoading);
    }

    return { lotStatuses, loading };
}

export function usePackageTypes(refreshToken, businessUnitCode, gradeName, includeAlternativeGrades) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [packageTypes, setPackageTypes] = useState([]);

    useEffect(() => {
        async function getPackageTypes() {
            let url = `${baseUrl}/packageType`;
            let params = new URLSearchParams();
            if (businessUnitCode) {
                params.append('businessUnitCode', businessUnitCode);
            }

            if (gradeName) {
                params.append('gradeName', gradeName);
            }

            if (includeAlternativeGrades) {
                params.append('includeAlternativeGrades', includeAlternativeGrades);
            }

            url = url + "?" + params.toString();
            let errorMessagePrefix = "Failed to get PackageTypes: ";
            await fetchHelper(fetchDataAuthenticated, url, setPackageTypes, errorMessagePrefix);
        }

        getPackageTypes();
    }, [businessUnitCode, fetchDataAuthenticated, refreshToken]);

    return packageTypes;
}

export function useRecipeToPackageTypes(recipeId, refreshToken) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [recipeToPackageTypes, setRecipeToPackageTypes] = useState([]);

    useEffect(() => {
        async function getRecipeToPackageTypes() {
            let url = `${baseUrl}/recipeToPackageType`;
            if (recipeId) {
                url += `?recipeId=${recipeId}`;
            }
            let errorMessagePrefix = "Failed to get PackageTypes: ";
            await fetchHelper(fetchDataAuthenticated, url, setRecipeToPackageTypes, errorMessagePrefix);
        }

        getRecipeToPackageTypes();
    }, [recipeId, refreshToken]);

    return recipeToPackageTypes;
}

const fetchHelper = async (fetchDataAuthenticated, url, setData, errorMessagePrefix, setLoading = undefined) => {
    await fetchDataAuthenticated(url)
        .then(async response => {
            if (response.ok) {
                return response.json();
            }
            throw new Error(await response.json());
        })
        .then(data => {
            setData(data);
        })
        .catch(error => {
            console.error(errorMessagePrefix + error.message);
        })
        .finally(() => {
            setLoading && setLoading(false);
        });
};